import React, { useEffect } from "react";
import axios from "axios";
import {config} from  '../library/comoda'

interface SubmitProps {
    id: string
    name?: string
    classe?:string
    value:string
    endpoint:string
    campi:any
    setStatoResponse?:any
}
 
const Submit: React.FC<SubmitProps> = ({
    value='',
    endpoint,
    campi,
    classe,
    setStatoResponse

}) => {
  const manicoClick= async () =>{let response = await axios.post(endpoint,
    campi,
    config
    )
    setStatoResponse(response.data);
    }
  
  
  useEffect(() => {
  }, []); // Runs only once after the initial render.
  return (
    <div>
   <input type='button'
   className={classe}
   value={value}
   onClick ={(event : React.MouseEvent<HTMLInputElement>) => manicoClick()}
   ></input>
    </div>
  );
};

export default Submit;

